import {
  Backdrop,
  Grid,
  Paper,
  Box, 
  Typography,
  Tab,
  Tabs,
  Modal, TextField,
  Button, 
  FormControl, InputLabel,Select,
  MenuItem,IconButton,
  Divider, CircularProgress, Checkbox, FormControlLabel, Card, 
  Dialog, DialogActions, DialogContent, DialogTitle
} from "@mui/material";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import CloseIcon from "@mui/icons-material/Close";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import RoomServiceIcon from "@mui/icons-material/RoomService";
import DefaultContainer from "../components/DefaultContainer";
import { connect } from "react-redux";
import DefaultHeader from "../components/DefaultHeader";
import Toast from "../components/Snackbar";
import ls from "local-storage";
import Warning from "../components/Warning";
import SkeletonOrder from "../components/SkeletonOrder";
import dayjs from "dayjs";
import { getAreas, getTableGroups, getByTableGroupID, createAndPay,createReservation, getAreaImages } from "../services/Reservation";
import MoneyFormat from "../components/MoneyFormat";
import { getPartnerPolicies } from "../services/Partners";
import customParseFormat from "dayjs/plugin/customParseFormat";
const SelectTableScreen = ({ props, cartData, userDetail }) => {
    const navigate = useNavigate();
    const partnerID = ls.get('sfPartner').id
    const [categoryIndex, setCategoryIndex] = useState(0);
    const [partnerDetails, setPartnerDetails] = useState(ls.get("sfPartner"));
    const [menus, setMenus] = useState([]);
    const location = useLocation();
    const [isOpen, setIsOpen] = useState(false);
    const [status, setStatus] = useState(0);
    const [width, setWindowWidth] = useState(0);
    const [height, setWindowHeight] = useState(0);
    const [isOpeningHour, setIsOpeningHour] = useState(false);
    const [msgToast, setMsgToast] = useState("");
    const [loading, setLoading] = useState(false);
    const hours = new Date().getHours();
    const minutes = new Date().getMinutes();
    const seconds = new Date().getSeconds();
    const [selectedTab, setSelectedTab] = useState(0);
    const [openModal, setOpenModal] = useState(false);
    const [reservationModal, setReservationModal] = useState(false);
    const [selectedTime, setSelectedTime] = useState(null);
    const [selectedTable, setSelectedTable] = useState(null);
    const [selectedTableGroup, setSelectedTableGroup] = useState(null);
    const [areas, setAreas] = useState([])
    const [tableGroups, setTableGroups] = useState([])
    const [tableListByGroupID, setTableListByGroupID] = useState([])
    const [customerName, setCustomerName] = useState(ls.get('redux_localstorage_simple').userData[0]? ls.get('redux_localstorage_simple').userData[0].name:"")
    const [customerPhone, setCustomerPhone] = useState(ls.get('redux_localstorage_simple').userData[0]? ls.get('redux_localstorage_simple').userData[0].phone:"")
    const [customerEmail, setCustomerEmail] = useState(ls.get('redux_localstorage_simple').userData[0]? ls.get('redux_localstorage_simple').userData[0].email:"")
    const [description, setDescription] = useState("");
    const [isLoadingReservasi , setIsLoadingReservasi] = useState(false)
    const [partnerPolicies, setPartnerPolicies] = useState([])
    const [isValid, setIsValid] = useState(false)
    const [areaImage, setAreaImage] = useState([])
    const [adult, setAdult] = useState(2)
    const [child, setChild] = useState(0)
    const [maxPerson, setMaxPerson] = useState([])
    const [error, setError] = useState(false);
    const bookingfee_customer_reservation = ls.get('sfPartner').bookingfee_customer_reservation;
    const [isDialogOpen, setIsDialogOpen] = useState(false)
    const images = [
        {id:0, image:partnerDetails?.img_map} || {id:0, image:""},
        ...(areaImage || [])
    ];
    const settings = {
        dots: true,          // Show navigation dots
        infinite: true,      // Enable infinite looping
        speed: 500,         // Transition animation speed
        slidesToShow: 1,     // Show one image at a time
        slidesToScroll: 1,   // Scroll one image at a time
        arrows: true,        // Show navigation arrows
        adaptiveHeight: true, // Adjust height dynamically
        autoplay: true,      // Enable auto slide
        autoplaySpeed: 3000, // Change slide every 2 seconds (2000ms)
      };

    const getTableGroupList = async () => {
        const response = await getTableGroups(ls.get("sfPartner").id, ls.get('reservation_time').customDate);
        const tableGroups = response.tableGroups
        return tableGroups; // ✅ Return hasilnya
    };

    const getAreasData = async () => {
        const response = await getAreas(ls.get("sfPartner").id,(ls.get('reservation_time').customDate)+ " " + ls.get('reservation_time').customTime + ":00");
        const groupedAreas = response.areas
        return groupedAreas; // ✅ Return hasilnya
    }

    const getAreaImageF = async (id) => {
        const response = await getAreaImages(id);
        const areaImages = response.images
        return areaImages;
    }

    const getTableByGroupIDList = async (tableGroups) => {
        let tablelist = []
        for (let i = 0; i < tableGroups.length; i++) {
        const id_group = (tableGroups[i]).id;
        const response = await getByTableGroupID(ls.get("sfPartner").id, (ls.get('reservation_time').customDate+ " " + ls.get('reservation_time').customTime + ":00"), id_group);
        tablelist.push(response.areas)
        }
        let tablelistCombine = [];
        for (let i = 0; i < tablelist.length; i++) {
        tablelistCombine.push(tablelist[i])
        
        }   
        tablelist.push(tablelistCombine)
        return tablelist
    }

    const getPartnerPoliciesF = async (id) => {
        const response  = await getPartnerPolicies(id);
        const policies = response.policies; 
        return policies
    }

useEffect(()=>{
    getAreasData().then(groupedAreas => {
      setAreas(groupedAreas);
      }
    );
    getAreaImageF(partnerID).then(images => {
      setAreaImage(images);
      }
    );
    getTableGroupList().then(tableGroups => {
      setTableGroups(tableGroups);
      getTableByGroupIDList(tableGroups).then(tablelist => {
        setTableListByGroupID(tablelist)
      });
      }
    );
    // console.log(customDate);
    
  },[ls.get('reservation_time').customTime,ls.get('reservation_time').customDate])


    const handleData = (customTime, customDate, adult, child, selectedTable) => {
        const data = {
            customTime : customTime,
            customDate : customDate,
            adult : adult,
            child : child,
            selectedTable : selectedTable
        }
        ls.set('reservation_time',data)
        return data
    }

console.log(tableListByGroupID);

    return(
    <DefaultContainer>
        <Grid
            item
            xs={12}
            style={{
            padding: 15,
            fontWeight: 500,
            fontSize: 20,
            textAlign: "center",
            background: "#fff",
            wordWrap: "breakWord",
            }}
        >
            <DefaultHeader
            title={"Reservasi di "+partnerDetails.name}
            url={`/reservation?partnerID=${ls.get("partnerID")}&tableID=${ls.get(
                "tableID"
            )}`}
            />
        </Grid>
        <Grid item xs={11}>
            <Slider {...settings}>
                {images.map((src, index) => (
                <div key={index}>
                <img
                    alt={`image-${index}`}
                    src={src.image==="" ? "/assets/img/logo/ur-biru.webp":src.image}
                    style={{
                    width: "100%",
                        height: "300px", // Set a fixed height (adjust as needed)
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "8px"
                    }}
                />
                </div>
            ))}
            </Slider>
            </Grid>
        {ls.get('reservation_time').customTime && ls.get('reservation_time').customDate &&
                <FormControl fullWidth sx={{mt:3}}>
                        <InputLabel id="demo-simple-select-label" sx={{m:1}}>Pilih Grup Meja</InputLabel>
                        <Select
                        labelId="demo-simple-select-label"
                        value={selectedTableGroup ? {id:"0", name:"Semua Meja"}:selectedTableGroup?.name}
                        onChange={(e)=>{
                            setSelectedTableGroup({i:e.target.value, id:tableGroups[e.target.value]?.id ? tableGroups[e.target.value].id:"0", name:tableGroups[e.target.value]?.name ? tableGroups[e.target.value].name : "Semua Meja"})
                        }}
                        sx={{mx:2,}}
                        >
                        <MenuItem value={tableGroups.length}>Semua Meja</MenuItem>
                        {tableGroups.map((group,i)=> <MenuItem value={i}>{group.name}</MenuItem>)}
                        </Select>
                </FormControl>}
                {/* GRID MEJA */}
                {tableGroups && selectedTableGroup &&
                <Grid container spacing={2} sx={{ mt: 1,}}>
                {selectedTableGroup.i !== tableGroups.length ? (
                    tableListByGroupID[selectedTableGroup.i] && tableListByGroupID[selectedTableGroup.i].length > 0 ? (
                        tableListByGroupID[selectedTableGroup.i].map((table, index) => (
                            <Grid item xs={4} key={index}>
                                <Button
                                    disabled={table.reservationStatus === "1"}
                                    variant={selectedTable === table ? "contained" : "outlined"}
                                    sx={{
                                        backgroundColor: selectedTable === table ? "primary.main" : "transparent",
                                        color: selectedTable === table ? "white !important" : "primary.main",
                                        borderColor: "primary.main",
                                    }}
                                    fullWidth
                                    onClick={() => {
                                        setSelectedTable(table);
                                        setOpenModal(true);
                                    }}
                                >
                                    {table.idmeja}
                                </Button>
                            </Grid>
                        ))
                    ) : (
                        <Grid  item xs={12} sx={{ backgroundColor: "#e0e0e0", p: 3, borderRadius: 3, textAlign: "center", mt: 2 }}>
                            <Typography>Meja tidak tersedia</Typography>
                        </Grid>
                    )
                ) : (
                    areas.length > 0 ? (
                        areas.map((table, index) => (
                            <Grid item xs={4} key={index}>
                                <Button
                                    disabled={table.reservationStatus === "1"}
                                    variant={selectedTable === table ? "contained" : "outlined"}
                                    sx={{
                                        backgroundColor: selectedTable === table ? "primary.main" : "transparent",
                                        color: selectedTable === table ? "white !important" : "primary.main",
                                        borderColor: "primary.main",
                                    }}
                                    fullWidth
                                    onClick={() => {
                                        setSelectedTable(table);
                                        setOpenModal(true);
                                    }}
                                >
                                    {table.idmeja}
                                </Button>
                            </Grid>
                        ))
                    ) : (
                        <Grid  item xs={12} sx={{ backgroundColor: "#e0e0e0", p: 3, borderRadius: 3, textAlign: "center", mt: 2 }}>
                            <Typography>Meja tidak tersedia</Typography>
                        </Grid>
                    )
                )}

                </Grid>}
                {!selectedTableGroup &&
                    <Grid item xs={4} sx={{backgroundColor:"#e0e0e0", p:3, borderRadius:3, textAlign:"center", mt:2}}>
                        <Typography>Grup meja belum dipilih</Typography>
                    </Grid>
                }
                <Modal open={selectedTable && openModal} onClose={()=>setOpenModal(!openModal)}>
                <Box
                    sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 400,
                    bgcolor: "background.paper",
                    boxShadow: 24,
                    p: 3,
                    borderRadius: 2,
                    }}
                >
        {/* SELECTED TABLE INFO */}
        {selectedTable && (
            <Grid container spacing={2} textAlign="center">
                <Grid item xs={12}>
                <Typography fontWeight="bold">{selectedTable?.name + " " + `(${selectedTable.idmeja})`}</Typography>
                </Grid>

                <Grid item xs={12}>
                <img
                    alt=""
                    src={
                    selectedTable?.image !== ""
                        ? selectedTable?.image
                        : "/assets/img/image-not-found.png"
                    }
                    style={{
                    width: selectedTable?.image !== "" ? "100%" : "50%",
                    height: selectedTable?.image !== "" ? "100%" : "50%",
                    objectFit: "cover",
                    objectPosition: "center",
                    }}
                />
                </Grid>

                <Grid item xs={12}>
                <Typography fontWeight="bold">
                    Maksimal {selectedTable?.capacity} Tamu
                </Typography>
                </Grid>

                <Grid item xs={12}>
                <Typography fontWeight="bold">
                    Durasi {selectedTable?.duration} {selectedTable.duration_metric}
                </Typography>
                </Grid>

                <Grid item xs={12}>
                <Typography fontWeight="bold">
                    Minimum spend Rp <MoneyFormat value={selectedTable?.minimum_transaction} />++
                </Typography>
                </Grid>

                <Grid item xs={12}>
                <Typography>{selectedTable?.description}</Typography>
                </Grid>

                {/* Close Button */}
                <Grid item xs={12} display="flex" justifyContent="space-between" alignItems="center">
                <Button variant="contained" style={{color: "white"}} color="primary" onClick={()=>{setOpenModal(!openModal);setSelectedTable(null)}}>
                    Pilih meja lain
                </Button>
                <Button variant="contained" style={{color: "white"}} color="primary" onClick={()=>{navigate('/reservation-confirmation', {state: 
                    handleData(ls.get('reservation_time').customTime, ls.get('reservation_time').customDate, ls.get('reservation_time').adult, ls.get('reservation_time').child, selectedTable)})}}>
                    Pilih meja ini
                </Button>
                </Grid>
            </Grid>
            )}
        </Box>
        </Modal>
    </DefaultContainer>
    );
    }
    const mapStateToProps = (state) => {
    return {
        currency: state.currencyData,
        // cartData: state.cartData,
        cartData: state.cartData.filter(
        (data) => data.partnerID === ls.get("partnerID")
        ),
        userDetail: state.userData[state.userData.length - 1],
        wishlistData: state.wishlistData,
        compareData: state.compareData,
    };
};
export default connect(mapStateToProps, null)(SelectTableScreen);
